import React from 'react';
import { Box } from '@mui/material';
import AdvisoryCloudLogo from './../components/AdvisoryCloudLogo';

const PublicRegistration = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 0,
        height: '100%',
        width: '100%',
        mb: '100px',
      }}
    >
      <Box
        sx={{
          top: '20px',
          transform: 'none',
          zIndex: 1,
        }}
      >
        <AdvisoryCloudLogo
          removeHyperlink
          onClick={() => {
            window.location.assign('https://www.advisorycloud.com');
          }}
          width={160}
        />
      </Box>{' '}
      {children}
    </Box>
  );
};

export default PublicRegistration;
